import {getDict} from "@/assets/Js/utils";

const dict = {
    state: {

    },
    mutations: {
        SET_DICT(state,data) {
            state[data.key] = data.value;
        }
    },
    actions: {
        SET_DICT({ state,rootState,commit,dispatch,getters },key) {
            return new Promise(async (resolve, reject) => {
                let arr = await getDict(key) || [];
                commit("SET_DICT",{
                    key,
                    value : arr,
                });
                resolve(arr);
            })
        },
    }
}

export default dict;
